import "./App.css";
import HomePage from "./pages/HomePage";
import homeImg from "./assets/images/homeImg.webp";
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <div>
      <div className="relative w-full h-screen">
        <img
          src={homeImg}
          alt=""
          className="absolute inset-0 w-full object-cover"
          style={{
            maskImage:
              "linear-gradient(to bottom, black 80%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 80%, transparent 100%)",
          }}
        />
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent" />
        </div>
        <div className="absolute inset-0">
          <HomePage />
        </div>
      </div>
      <Analytics />
    </div>
  );
}

export default App;
